import { Cell, CellType } from '../_base/table-cell.entity';

export class TextCell extends Cell {
    constructor(
        public readonly value: string | null,
        public readonly wrapText: boolean = true,
        public readonly parseHtml: boolean = true,
        public readonly minWidthInRem?: number,
        public readonly tooltip?: string,
        public readonly disabled = false
    ) {
        super(CellType.TEXT);
    }
}
